import { Link } from 'react-router-dom';
import { useState } from 'react';
import NFCteamLogos from '../../assets/NFCteamLogos';
import '../../css/NFLhomepage.css';
import nfcLogo from '../../assets/nfc-logo.png';

const NFChomePage = () => {
    const [showPopup, setShowPopup] = useState(false);
    const [standingsView, setStandingsView] = useState('division');

    const getTeamPath = (teamName) => {
        return `/sports/football/nfc/teams/${teamName
            .toLowerCase()
            .replace(/\./g, '')
            .replace(/\s+/g, '-')}`;
    };

    const nfcDivisions = [
        {
            division: "NFC East",
            teams: [
                { rank: 3, name: "Philadelphia Eagles", record: "11-6" },
                { rank: 12, name: "Dallas Cowboys", record: "7-9" },
                { rank: 14, name: "Washington Commanders", record: "5-12" },
                { rank: 15, name: "New York Giants", record: "4-13" }
            ]
        },
        {
            division: "NFC North",
            teams: [
                { rank: 2, name: "Chicago Bears", record: "11-6" },
                { rank: 7, name: "Green Bay Packers", record: "9-7" },
                { rank: 8, name: "Minnesota Vikings", record: "9-8" },
                { rank: 9, name: "Detroit Lions", record: "9-8" }
            ]
        },
        {
            division: "NFC South",
            teams: [
                { rank: 4, name: "Carolina Panthers", record: "8-9" },
                { rank: 10, name: "Tampa Bay Buccaneers", record: "8-9" },
                { rank: 11, name: "Atlanta Falcons", record: "8-9" },
                { rank: 13, name: "New Orleans Saints", record: "6-11" }
            ]
        },
        {
            division: "NFC West",
            teams: [
                { rank: 1, name: "Seattle Seahawks", record: "14-3" },
                { rank: 5, name: "Los Angeles Rams", record: "12-5" },
                { rank: 6, name: "San Francisco 49ers", record: "12-5" },
                { rank: 16, name: "Arizona Cardinals", record: "3-14" }
            ]
        }
    ];

    const nfcConference = [];

    nfcDivisions.forEach((divisionInfo) => {
        divisionInfo.teams.forEach((team) => {
            nfcConference.push({
                rank: team.rank,
                name: team.name,
                record: team.record,
                division: divisionInfo.division
            });
        });
    });

    nfcConference.sort((a, b) => a.rank - b.rank);

    return (
        <main id="nfl-page">
            <section id="conference-hero">
                <div id="conference-logo-side">
                    <img id="conference-corner-logo" src={nfcLogo} alt="NFC logo" />
                </div>

                <div id="conference-hero-main">
                    <h2 id="quest">The National Football Conference</h2>
                    <h2 id="quest">(NFC)</h2>

                    <div id="nfl-buttons">
                        <section
                            className="nfl-button-box"
                            onClick={() => setShowPopup(true)}
                        >
                            <h2>Games</h2>
                        </section>

                        <Link to="/sports/football/nfc/teams" className="nfl-link">
                            <section className="nfl-button-box">
                                <h2>Teams</h2>
                            </section>
                        </Link>
                    </div>
                </div>

                <div className="conference-hero-spacer"></div>
            </section>

            {showPopup && (
                <div className="popup-overlay" onClick={() => setShowPopup(false)}>
                    <div className="popup-box" onClick={(e) => e.stopPropagation()}>
                        <p>
                            The NFL schedule will be released in May 2026. The games page is not yet available.
                        </p>
                        <button onClick={() => setShowPopup(false)}>Close</button>
                    </div>
                </div>
            )}

            <section id="nfl-standings-section">
                <div id="nfl-standings-top">
                    <h3>2025 NFC Standings</h3>

                    <div id="nfl-view-buttons">
                        <button
                            className={standingsView === 'division' ? 'nfl-view-btn active-nfl-view' : 'nfl-view-btn'}
                            onClick={() => setStandingsView('division')}
                        >
                            By Division
                        </button>

                        <button
                            className={standingsView === 'conference' ? 'nfl-view-btn active-nfl-view' : 'nfl-view-btn'}
                            onClick={() => setStandingsView('conference')}
                        >
                            Full Conference
                        </button>
                    </div>
                </div>

                {standingsView === 'division' ? (
                    <div id="nfl-division-grid">
                        {nfcDivisions.map((divisionInfo) => (
                            <div key={divisionInfo.division} className="nfl-division-box">
                                <h4>{divisionInfo.division}</h4>

                                <div className="nfl-team-list">
                                    {divisionInfo.teams.map((team, index) => (
                                        <Link
                                            key={team.name}
                                            to={getTeamPath(team.name)}
                                            className="nfl-team-row"
                                            style={{ textDecoration: 'none', color: 'inherit' }}
                                        >
                                            <div className="nfl-team-left">
                                                <span className="nfl-num">{index + 1}.</span>
                                                <img
                                                    src={NFCteamLogos[team.name]}
                                                    alt={team.name}
                                                    className="nfl-team-logo"
                                                />
                                                <span className="nfl-team-name">{team.name}</span>
                                            </div>

                                            <span className="nfl-record">{team.record}</span>
                                        </Link>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <div className="nfl-conference-box">
                        <div className="nfl-conference-header">
                            <span>Rank</span>
                            <span></span>
                            <span>Team</span>
                            <span>Record</span>
                            <span className="nfl-division-col">Division</span>
                        </div>

                        {nfcConference.map((team) => (
                            <Link
                                key={team.name}
                                to={getTeamPath(team.name)}
                                className="nfl-conference-row"
                                style={{ textDecoration: 'none', color: 'inherit' }}
                            >
                                <span className="nfl-conf-rank">{team.rank}</span>
                                <img
                                    src={NFCteamLogos[team.name]}
                                    alt={team.name}
                                    className="nfl-team-logo"
                                />
                                <span className="nfl-conf-team-name">{team.name}</span>
                                <span className="nfl-conf-record">{team.record}</span>
                                <span className="nfl-conf-division nfl-division-col">{team.division}</span>
                            </Link>
                        ))}
                    </div>
                )}
            </section>
        </main>
    );
};

export default NFChomePage;